import { render, staticRenderFns } from "./CreateReceiptService.vue?vue&type=template&id=0328511c"
import script from "./CreateReceiptService.vue?vue&type=script&lang=js"
export * from "./CreateReceiptService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports